<template>
  <div class="Other">Other</div>
</template>

<script>
export default {
  name: "Other",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .other {
  background-image: url("../assets/pic21.jpg");
}
</style>
